import { render, staticRenderFns } from "./ClusterSummaryCardOwners.vue?vue&type=template&id=2633ae68&scoped=true&"
import script from "./ClusterSummaryCardOwners.vue?vue&type=script&setup=true&lang=js&"
export * from "./ClusterSummaryCardOwners.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2633ae68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VDataTable,VSkeletonLoader})
